export { default as getStates } from './getStates';

export type { GetStatesFunction, GetStatesPayload, State } from './getStates.type';
